module.exports = "https://cdn.dove.it/_next/static/public/assets/adv/quintiliano5.6d7b385a8266518792c94b8a98624fe3.jpg";